import { Badge, Grid, Group, Text, ThemeIcon } from "@mantine/core";
import {
  IconCalculator,
  IconFileText,
  IconTargetArrow,
  IconTrophy,
  IconUsers,
  IconUsersGroup,
} from "@tabler/icons-react";
import adminClasses from "../AdminDashboardView/AdminDashboardView.module.css";
import salesClasses from "./SalesDashboardView.module.css";
import { EMPTY } from "./salesDashboard.constants";

const KPI_ICONS = [IconUsers, IconTrophy, IconTargetArrow, IconFileText, IconCalculator, IconUsersGroup];
const KPI_PLACEHOLDERS = Array.from({ length: 6 }, (_, index) => ({ label: `kpi-${index}` }));
const BADGE_CLASS = {
  green: salesClasses.kpiBadgeGreen,
  purple: salesClasses.kpiBadgePurple,
  red: salesClasses.kpiBadgeRed,
  neutral: salesClasses.kpiBadgeNeutral,
};

const SalesDashboardKpiGrid = ({ items, isLoading }) => (
  <Grid gutter={12}>
    {(items.length ? items : KPI_PLACEHOLDERS).map((item, index) => {
      const Icon = KPI_ICONS[index];
      const iconTone = item.iconTone || "violet";
      const iconClass =
        salesClasses[`kpiIcon${iconTone.charAt(0).toUpperCase()}${iconTone.slice(1)}`] ||
        salesClasses.kpiIconViolet;

      return (
        <Grid.Col span={{ base: 12, xs: 6, sm: 4, lg: 2 }} key={item.label}>
          <div className={`${adminClasses.card} ${salesClasses.kpiCard}`}>
            <Group justify="space-between" align="flex-start" wrap="nowrap" mb={10}>
              <ThemeIcon size={36} radius="md" className={iconClass}>
                <Icon size={18} stroke={1.7} />
              </ThemeIcon>
              <Text className={salesClasses.kpiValue}>{isLoading ? EMPTY : item.value}</Text>
            </Group>
            <Text className={salesClasses.kpiLabel}>{items.length ? item.label : "\u00a0"}</Text>
            {item.badge ? (
              <Badge
                variant="light"
                radius="sm"
                className={BADGE_CLASS[item.badgeTone] || BADGE_CLASS.neutral}
                mt={8}
              >
                {item.badge}
              </Badge>
            ) : null}
          </div>
        </Grid.Col>
      );
    })}
  </Grid>
);

export default SalesDashboardKpiGrid;
